import { render } from "./Swiper_2.vue?vue&type=template&id=4c2fb857"
import script from "./Swiper_2.vue?vue&type=script&lang=js"
export * from "./Swiper_2.vue?vue&type=script&lang=js"

import "./Swiper_2.vue?vue&type=style&index=0&id=4c2fb857&lang=scss"

import exportComponent from "/var/www/sites/qiyas.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__